import { useAuthContext } from "@/context/auth-context";
import type { GetShareTargetsDto } from "@/lib/gen-api";
import { groupControllerGetShareTargets } from "@/lib/gen-api/sdk.gen";
import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import { queryKeys } from "../lib/query-keys";

const EMPTY_SHARE_TARGETS: GetShareTargetsDto = {
  teams: [],
  people: [],
};

export const useShareTargetsData = (organizationUuid?: string) => {
  const { token, authDetails } = useAuthContext();
  const isApiReady = useIsApiReady();

  const { data, isPending, error } = useQuery({
    enabled: isApiReady && !!authDetails?.uuid && !!organizationUuid,
    queryKey: queryKeys.shareTargets(authDetails?.uuid, organizationUuid),
    queryFn: () =>
      groupControllerGetShareTargets({
        query: {
          filter: { organization_uuid: organizationUuid! },
        },
      }).then((response) => response.data ?? EMPTY_SHARE_TARGETS),
  });

  if (!token) {
    return { ...EMPTY_SHARE_TARGETS, isLoading: false, error: null };
  }

  return {
    teams: data?.teams ?? [],
    people: data?.people ?? [],
    isLoading: isPending,
    error,
  };
};
